<footer class="footer">
  <div class="container">
    <div class="footer-content">
      <div class="footer-logo">
        <a href="#">
          <span class="logo-text">Zero-Waste</span>
        </a>
        <p>
          Ensemble, luttons contre le gaspillage alimentaire et construisons un
          avenir plus durable.
        </p>
        <div class="social-links">
          <a
            href="https://www.facebook.com/people/Zero-Waste/61575538063241/"
            aria-label="Facebook"
            target="_blank"
            ><i class="fab fa-facebook-f"></i
          ></a>
          <a
            href="https://www.instagram.com/zero_waste_tunisie/"
            aria-label="Instagram"
            target="_blank"
            ><i class="fab fa-instagram"></i
          ></a>
          <a
            href="https://www.linkedin.com/company/zero-waste-tunisie"
            aria-label="LinkedIn"
            target="_blank"
            ><i class="fab fa-linkedin-in"></i
          ></a>
        </div>
      </div>

      <div class="footer-links">
        <div class="footer-links-column">
          <h3>Commerçants</h3>
          <ul>
            <li><a routerLink="/create-account">S'inscrire</a></li>
            <li>
              <a href="https://store.zero-waste.pro/login">Se connecter</a>
            </li>
          </ul>
        </div>

        <div class="footer-links-column">
          <h3>Contact</h3>
          <ul>
            <li><i class="fas fa-envelope"></i> contact&#64;zero-waste.pro</li>
            <li><i class="fas fa-phone"></i> +33 7 66 82 46 98</li>
            <li>
              <i class="fas fa-map-marker-alt"></i> 19 rue Sialana Ibn khouldoun
              Tunisie
            </li>
          </ul>
        </div>

        <div class="footer-links-column">
          <h4>Légal</h4>
          <ul>
            <li>
              <a class="cursor" (click)="routerTerm()"
                >Conditions d'utilisation</a
              >
            </li>
            <li>
              <a class="cursor" (click)="routerPrivacy()"
                >Politique de confidentialité</a
              >
            </li>
            <li>
              <a class="cursor" routerLink="/legal-notice">Mentions légales</a>
            </li>
            <li><a class="cursor" routerLink="/about-us">À propos</a></li>
            <li><a class="cursor" routerLink="/cookies">Cookies</a></li>
            <li>
              <a class="cursor" (click)="routerDelete()"
                >Supprimer mon compte</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="footer-bottom">
      <p>&copy; {{ currentYear }} Zero-Waste. Tous droits réservés.</p>
    </div>
  </div>
</footer>
